import { OpenBankingProvider } from '@finxone-platform/shared/sys-config-types';
import { ProjectSettingsState } from '@app/finxone-web-frontend/app/lib/state/project-settings.state';
import { Store } from '@ngxs/store';

/**
 * Mirrors CommonService.getOpenBankingProvider's resolution (account-service):
 * - Defaults to gocardless
 * - Auto-switches to universal-sandbox when that's the main account_service provider
 * - An explicit openBankingConfig override (e.g. natwest-payit) wins over both
 */
export function getOpenBankingProvider(store: Store): OpenBankingProvider {
  const projectSettings = store.selectSnapshot(ProjectSettingsState.getProjectSettings);
  const accountServiceConfig = projectSettings.projectConfig?.account_service;

  return (
    accountServiceConfig?.openBankingConfig?.provider ??
    (accountServiceConfig?.provider === 'universal-sandbox'
      ? OpenBankingProvider.UNIVERSAL_SANDBOX
      : OpenBankingProvider.GOCARDLESS)
  );
}
